import { render, staticRenderFns } from "./ResendEmailVerificationForm.vue?vue&type=template&id=8c14a060"
import script from "./ResendEmailVerificationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ResendEmailVerificationForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports